import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    h2: "Collecte des données",
    paragraphs: [
      "Les données transmises via le formulaire d'ouverture de dossier (identité, coordonnées professionnelles, SIRET, contexte de la demande) sont collectées directement auprès de vous, dans le cadre de votre démarche volontaire.",
      "Aucune donnée n'est collectée à des fins publicitaires et aucune information n'est cédée ou vendue à des tiers.",
    ],
  },
  {
    h2: "Secret Professionnel et NDA",
    paragraphs: [
      "Toutes les informations communiquées à ACS Corporate sont couvertes par le secret professionnel le plus strict.",
      "Sur simple demande, un accord de confidentialité (NDA) peut être signé avant tout échange de pièces sensibles (FEC, liasses fiscales, documents stratégiques).",
    ],
  },
  {
    h2: "Finalité du traitement",
    paragraphs: [
      "Les données sont utilisées exclusivement pour l'étude de votre demande, la préparation de votre Mémo Flash d'évaluation et le suivi de la relation avec ACS Corporate.",
      "Elles sont conservées pendant une durée maximale de [durée à compléter] et hébergées de manière sécurisée.",
    ],
  },
  {
    h2: "Droits des utilisateurs (RGPD)",
    paragraphs: [
      "Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez de droits d'accès, de rectification, d'effacement, de portabilité, de limitation et d'opposition concernant vos données personnelles.",
      "Pour exercer ces droits : contact@acs-corporate.com. Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).",
    ],
  },
];

export default function Confidentialite() {
  return <LegalPage title="Politique de Confidentialité" sections={SECTIONS} />;
}
